import { AB_TESTS } from '../services/abTesting/abTests';
import { useGetABTestValue } from '../services/abTesting/useGetABTest';

const FORCE_GROUP = 2;
export const useHardAnnualOnlyTrialPaywall = () => {
  const hardAnnualOnlyTrialPaywall: number | null = FORCE_GROUP;
  // const hardAnnualOnlyTrialPaywall: number | null = useGetABTestValue(
  //   AB_TESTS.HARD_ANNUAL_ONLY_TRIAL_PAYWALL
  // );

  // 0 - control
  // 1 - hard paywall, no slideshow
  // 2 - hard paywall, slideshow

  const isHardAnnualOnlyTrialPaywallControl = !hardAnnualOnlyTrialPaywall;
  const isHardAnnualOnlyTrialPaywallNoSlideshow = hardAnnualOnlyTrialPaywall == 1;
  const isHardAnnualOnlyTrialPaywallWithSlideshow = hardAnnualOnlyTrialPaywall == 2;

  const isHardPaywall =
    isHardAnnualOnlyTrialPaywallNoSlideshow || isHardAnnualOnlyTrialPaywallWithSlideshow;

  return {
    isHardPaywall,
    isHardAnnualOnlyTrialPaywallControl,
    isHardAnnualOnlyTrialPaywallNoSlideshow,
    isHardAnnualOnlyTrialPaywallWithSlideshow,
  };
};
